import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";
import ActivityFilter from "./ActivityFilter";
import AgeFilter from "./AgeFilter";
import BranchFilter from "./BranchFilter";
import DateFilter from "./DateFilter";
import ExtraFilter from "./ExtraFilter";
import LocationFilter from "./LocationFilter";

const ActivitiesFilter = () => {
	const { activityButtonId } = useContext(ActivitiesContext);

	return (
		<div className="activities__filter">
			<>
				<AgeFilter />
				<LocationFilter />
				<DateFilter />
				<ActivityFilter />
				{activityButtonId === "sportkamp" && <ExtraFilter />}
				{activityButtonId === "sportactiviteit" && <BranchFilter />}
			</>
		</div>
	);
};

export default ActivitiesFilter;
